import { Flex, Stack } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { AIDetectionFeature } from "./ai-detection-feature";

export const ProfessionalFeatures = () => {
    const { t } = useTranslation(["common"]);

    return (
        <Stack spacing={"0rem"} mt={"0.5rem"}>
            {/* <List.Item>{t("upgrade.pro.scan-limit")}</List.Item>
            <List.Item>{t("upgrade.pro.word-limit")}</List.Item> */}
            <AIDetectionFeature />
            <Flex align={"flex-start"} gap={"0.25rem"}>
                <IconCheck size={16} style={{ marginTop: "8px" }} />
                <p style={{fontSize: "14px"}}>{t("upgrade.pro.plagiarism-detection")}</p>
            </Flex>
            <Flex align={"flex-start"} gap={"0.25rem"}>
                <IconCheck size={16} style={{ marginTop: "8px" }} />
                <p style={{fontSize: "14px"}}>{t("upgrade.pro.follow-up-questions")}</p>
            </Flex>
            <Flex align={"flex-start"} gap={"0.25rem"}>
                <IconCheck size={16} style={{ marginTop: "8px" }} />
                <p style={{fontSize: "14px"}}>{t("upgrade.pro.fact-check")}</p>
            </Flex>
            <Flex align={"flex-start"} gap={"0.25rem"}>
                <IconCheck size={16} style={{ marginTop: "8px" }} />
                <p style={{fontSize: "14px"}}>{t("upgrade.pro.language-check")}</p>
            </Flex>
            <Flex align={"flex-start"} gap={"0.25rem"}>
                <IconCheck size={16} style={{ marginTop: "8px" }} />
                <p style={{fontSize: "14px"}}>{t("upgrade.pro.text-analysis")}</p>
            </Flex>
        </Stack>
    );
};
